import { post } from "aws-amplify/api";

export const LANGUAGE_PREFERENCE = 21;

export type SupportedLanguage = {
  lid: number;
  code: string;
  name: string;
};

export type PreferenceItem = {
  prefid: number;
  prefval: string;
};

export function asPreferenceItem(value: unknown): PreferenceItem | null {
  if (!value || typeof value !== "object") {
    return null;
  }

  const record = value as Record<string, unknown>;
  const prefid = record.prefid;
  const prefval = record.prefval;

  if (typeof prefid !== "number" || typeof prefval !== "string") {
    return null;
  }

  return { prefid, prefval };
}

export function getPreferenceItems(value: unknown) {
  return Array.isArray(value)
    ? value
        .map(asPreferenceItem)
        .filter((pref): pref is PreferenceItem => pref !== null)
    : [];
}

export function getLanguagePreferenceValue(preferences: unknown) {
  return (
    getPreferenceItems(preferences)
      .find((pref) => pref.prefid === LANGUAGE_PREFERENCE)
      ?.prefval.trim() ?? ""
  );
}

export function resolvePreferredLanguageCode(
  preferenceValue: string,
  supportedLanguages: SupportedLanguage[],
  fallback = "en",
) {
  if (!preferenceValue) {
    return fallback;
  }

  return (
    supportedLanguages.find(
      (lang) =>
        lang.code === preferenceValue ||
        String(lang.lid) === preferenceValue ||
        lang.name === preferenceValue,
    )?.code ?? fallback
  );
}

export async function getSupportedLanguages() {
  const { body } = await post({
    apiName: "apiVeroUser",
    path: "/list",
    options: {
      body: {
        meth: "getSupportedLanguages",
      },
    },
  }).response;

  const json = await body.json();
  return Array.isArray(json) ? (json as SupportedLanguage[]) : [];
}
